






import { Component, Vue } from "vue-property-decorator";
import Contact from "@/components/Contact.vue"; // @ is an alias to /src

@Component({
  components: {
    Contact
  }
})
export default class Start extends Vue {}
